import Api from 'libs/api';

class AdminOrdersApi extends Api {
  constructor() {
    super('admin/orders/');
  }
}

export default AdminOrdersApi;
